import React, { useState, useEffect, useRef } from "react";
import Svg from '../../components/icon_svg/icon_svg'
import Button from '../../components/button/button'
import ParentMenuItem from '../../components/parent_menu_item/parent_menu_item';
import SubMenuItem from '../../components/sub_menu_item/sub_menu_item';
import gsap from "gsap";
import { ProcessLink } from "../../global/helpers"



const Header = ({ data }) => {
  //Toggle Mobile Menu Classes
  const [menuClass, setMenuStateClass] = useState('');

  //Set sticky header class
  const [stickyClass, setStickyClass] = useState('');


  const menuRef = useRef(null)
  const subMenuRef = useRef(null)
  const svgRef = useRef(null)

  //SVG Icon object
  const svg_icon = {
    "svg_icon": data.header_logo,
    "link": { "url": "/" }
  }

  //Menu Items
  const loginLink = ProcessLink(data.login_link);
  const menuItems = data.menu.map((menu, index) => (<ParentMenuItem key={index} data={menu} stagger={index} />));

  const subMenuItems = (item) => {
    if (!item.sub_menu.length) return
    return item.sub_menu.map((item, index) => (
      <SubMenuItem key={index} data={item} />
    ))
  }

  useEffect(() => {
    window.addEventListener('scroll', sticky);
    window.addEventListener('load', sticky);
    window.addEventListener('resize', resizeHandler);

    return () => {
      window.removeEventListener('scroll', sticky);
      window.removeEventListener('load', sticky);
      window.removeEventListener('resize', resizeHandler);
    }
  })

  const sticky = e => {
    if (window !== undefined && window.scrollY > 0) {
      setStickyClass('sticky_header_enabled')
    } else {
      setStickyClass('')
    }
  }

  const resizeHandler = () => {
  }

  //Sets menu classes when window is resized, when hamburger menu is clicked and when you click outside of the mobile menu area.
  const menuState = (e) => {
    if (document.getElementById('header__mobile-menu').className === 'menu--show') {
      setMenuStateClass("");
      playCloseAnimations();
    } else {
      setMenuStateClass("menu--show");
      playOpenAnimations();
    }
  }

  const playOpenAnimations = () => {

    const parentElements = menuRef.current.children;
    for (let i = 0; i < parentElements.length; i++) {
      const element = parentElements[i]
      gsap.from(element, { autoAlpha: 0, y: 35, duration: 0.3, delay: i * 0.1, });
    }

    const subMenuElements = subMenuRef.current.children
    for (let i = 0; i < subMenuElements.length; i++) {
      const element = subMenuElements[i]
      gsap.from(element, { autoAlpha: 0, y: 35, duration: 0.3, delay: (i * 0.1) + 0.4, });
    }

    const svg = svgRef.current.children;
    gsap.to(svg[0], { attr: { x1: 16, y1: 15, x2: 34, y2: 34, }, duration: 0.5 })
    gsap.to(svg[1], { scaleY: 0, duration: 0.5 })
    gsap.to(svg[2], { attr: { x1: 16, y1: 34, x2: 34, y2: 16, }, duration: 0.5 });


    gsap.to('.animatedBackground', { height: '100vh', duration: 0.1})
  }

  const playCloseAnimations = () => {
    const svg = svgRef.current.children;
    gsap.to(svg[0], { attr: { x1: 14, y1: 18, x2: 37, y2: 18, }, duration: 0.5 })
    gsap.to(svg[1], { scaleY: 1, duration: 0.5 })
    gsap.to(svg[2], { attr: { x1: 14, y1: 32, x2: 30, y2: 32, }, duration: 0.5 });

    gsap.to('.animatedBackground', { height: '0', duration: 0.5})

  }

  return (
    <header className={stickyClass}>
      <div className="animatedBackground"></div>
      <div className="inner">
        <div className="header__logo">
          <Svg blok={svg_icon}></Svg>
        </div>
        <div className="login">
          <a href={loginLink.url} target={loginLink.target} rel={loginLink.rel} title={loginLink.title} className={loginLink.cssClass}>
            <span className="hide-on-mobile">Platform</span> Login
          </a>
        </div>
        <Button blok={data.cta_button}></Button>
        <div className="menu_container">
          <div id="header-menu" className={`header__menu ${menuClass}`} >
            <h3 className="outline">{data.menu_header}</h3>
            <div className="background"></div>
            <nav className="header__nav">
              <ul className="menu" id="menu-main-menu" ref={menuRef}>
                {menuItems}
              </ul>

              {/* CREATING SUB MENU */}
              <ul className="sub-menu">
                <div className="submenu_inner" ref={subMenuRef}>
                  {data.menu.map((item) => (
                    subMenuItems(item)
                  ))}
                </div>
              </ul>

            </nav>
            <div className="open-menu-cta">
              {data.cta_button && data.cta_button.length > 0 &&
                data.cta_button.map(button => {
                  const link = ProcessLink(button.content_target);
                  return (
                    <React.Fragment key={button._uid}>
                      <span>{button.Label}</span>
                      <a key={button.id} href={link.url} target={link.target} rel={link.rel} title={link.title} aria-label={link.title} className={"button " + button.Style}>
                        <span className="arrow">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" height={27} fill="currentColor"><path d="M233 239c9.4 9.4 9.4 24.6 0 33.9L73 433c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l143-143L39 113c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L233 239z"/></svg>
                        </span>
                        <div className='btn-bg top'></div>
                        <div className='btn-bg bottom'></div>
                      </a>
                    </React.Fragment>
                  )
                })
              }
            </div>
            {/* <Footer/> */}
          </div>
          <button id="header__mobile-menu" className={menuClass} aria-label="Open Menu" onClick={menuState}>
            <svg className='svgMenu' width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef}>
              <line x1="14" y1="18" x2="37" y2="18" stroke="white"/>
              <line x1="14" y1="25" x2="37" y2="25" stroke="white"/>
              <line x1="14" y1="32" x2="30" y2="32" stroke="white"/>
            </svg>
          </button>
        </div>
      </div>
    </header>
  )
};

export default Header;